import { MakeoverStudio } from "components/_dashboard/makeovers/MakeoverStudio";

type ListingMakeoversTabProps = {
  listingId: string;
  /** The listing's photo URLs to offer for editing. */
  images: string[];
};

export function ListingMakeoversTab({ listingId, images }: ListingMakeoversTabProps): JSX.Element {
  return <MakeoverStudio listingId={listingId} images={images} />;
}

export default ListingMakeoversTab;
